import type { CSSProperties } from 'react';

interface Props {
  t: (key: string) => string;
}

type Product = {
  slug: string;
  name: string;
  tagKey: string;
  swatch: string;
  accent: string;
  accent2: string;
  screenshot?: string;
};

const products: readonly Product[] = [
  {
    slug: 'papomaterno',
    name: 'Papo Materno',
    tagKey: 'product.papomaterno.tag',
    swatch: 'linear-gradient(135deg,#1D26BF,#495ae1)',
    accent: '#1D26BF',
    accent2: '#495ae1',
    screenshot: '/screenshots/papomaterno.png',
  },
  {
    slug: 'beluzi',
    name: 'Beluzi',
    tagKey: 'product.beluzi.tag',
    swatch: 'linear-gradient(135deg,#131f67,#1D26BF)',
    accent: '#131f67',
    accent2: '#1D26BF',
    screenshot: '/screenshots/beluzi.png',
  },
  {
    slug: 'personalburn',
    name: 'Personal Burn',
    tagKey: 'product.personalburn.tag',
    swatch: 'linear-gradient(135deg,#385770,#6BA1CC)',
    accent: '#385770',
    accent2: '#6BA1CC',
    screenshot: '/screenshots/personalburn.png',
  },
] as const;

export function Portfolio({ t }: Props) {
  return (
    <section className="section" id="portfolio">
      <div className="container">
        <div className="section-head reveal">
          <div className="label-row mono">
            <span className="num">01</span>
            <span>{t('portfolio.label')}</span>
            <span className="bar"></span>
          </div>
          <h2 className="h2">
            {t('portfolio.h2.a')} <span className="em">{t('portfolio.h2.em')}</span>
          </h2>
        </div>

        <div className="portfolio">
          {products.map((p) => {
            const stageStyle = {
              ['--p-accent' as string]: p.accent,
              ['--p-accent-2' as string]: p.accent2,
            } as CSSProperties;
            return (
              <article key={p.slug} className="product reveal">
                <div className="product-info">
                  <div className="product-meta mono">
                    <span className="swatch" style={{ background: p.swatch }}></span>
                    <span>{p.slug}</span>
                  </div>
                  <h3 className="product-name">{p.name}</h3>
                  <p className="product-tag">{t(p.tagKey)}</p>
                  <a
                    className="product-link mono"
                    href={`https://usehook.net/app/${p.slug}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {t('product.link')}
                    {p.slug} <span className="arr">↗</span>
                  </a>
                </div>

                <div className="product-stage" style={stageStyle}>
                  <div className="stage-bg"></div>
                  <div className="phone">
                    <div className="phone-notch"></div>
                    <div className="phone-screen">
                      {p.screenshot ? (
                        <img
                          className="phone-shot"
                          src={p.screenshot}
                          alt={`${p.name} — preview`}
                          loading="lazy"
                          decoding="async"
                          width={280}
                          height={607}
                        />
                      ) : (
                        <div className="phone-placeholder">
                          <div className="ph-icon"></div>
                          <span className="ph-label">{t('product.placeholder')}</span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
